import React, { useContext } from 'react';

import { Select } from 'antd';

import { ListContext } from '@contexts/ListContext';

const Option = Select.Option;

const VatSelector = ({ onChange, value, disabled, onBlur, emptyValue = false }) => {
    const { cachedList } = useContext(ListContext);
    const vatOptions = cachedList.taxmethods.items.VatCodes.filter((el) => !el.Disabled);

    return (
        <Select
            autoComplete="off"
            mode="single"
            value={value || undefined}
            placeholder="Select VAT code"
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            allowClear
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
            {/* {emptyValue && <Option value={null}>No VAT Code</Option>} */}
            {vatOptions.map((el) => (
                <Option key={el.Code} value={el.Code}>
                    {el.Name}
                </Option>
            ))}
        </Select>
    );
};

export default VatSelector;
